import React from 'react';
import {
  generateSizeTypeOptions,
  getSelectedSizeIds,
  updateMySizesWithSizeSelection,
} from '@helpers/utils/catalog/my-sizes-helpers';
import { SizeObjType, SizeCategorySize, MySizesStepType, MySizes as Sizes } from '@interfaces/models/mySizes';
import ToggleButton from '@components/catalog/toggle-button/toggle-button';
import TextSwatch from '@components/atoms/text-swatch/text-swatch';
import SizeAccordion from '../size-accordion/size-accordion';
import { iconMap } from '../editing/sizesMap';
import styles from './size-section.module.scss';

interface SizeSectionProps {
  title: string;
  sizeType: string;
  sizes: SizeObjType[];
  onSizeTypeChange: (id: string) => void;
  optionsIndex: number;
  editValue: Sizes;
  setEditValue: (value: Sizes) => void;
  options: MySizesStepType[];
  universe: string;
}

const SizeSection: React.FC<SizeSectionProps> = ({
  title,
  sizeType,
  sizes,
  onSizeTypeChange,
  optionsIndex,
  editValue,
  setEditValue,
  options,
  universe,
}) => {
  const handleSizeChange = (
    val: string,
    item: SizeCategorySize,
    checked: boolean,
    sizesData: SizeObjType[],
    sizeTypeData: string,
  ) => {
    const newValue = updateMySizesWithSizeSelection(editValue, sizeTypeData, item, checked, options, universe);
    setEditValue(newValue);
  };

  return (
    <>
      <h4 className={styles.size__title}>{title}</h4>
      <div className={styles.size__toggleBtnContainer}>
        <ToggleButton
          options={generateSizeTypeOptions(options, optionsIndex, editValue, iconMap)}
          value={sizeType}
          onChange={onSizeTypeChange}
        />
      </div>
      <div className={styles.size__container}>
        <SizeAccordion />
        <ul className={styles.size__list}>
          {sizes.map((item, index) => (
            <li key={`${item.id}-${item.label}`}>
              <TextSwatch
                htmlId={`${item.label}${index}-id`}
                customClass={styles.size__list__textSwatchOverwrite}
                checked={getSelectedSizeIds(editValue, sizeType).includes(item.id)}
                onChange={(e: React.SyntheticEvent, val?: string, checked?: boolean) => {
                  handleSizeChange(val || '', item, checked || false, sizes, sizeType);
                }}
                label={item.label}
              />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SizeSection;
